<template>
  <div class="bankAccounts">
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-md-9">
            <h1 class="fw-600 fs-24 mb-0">Dados Bancários</h1>
          </div>
          <div class="col-md-3 text-right text-end pt-2">
            <router-link class="btn btn-blue" to="/bank-accounts/create">
              <i class="fas fa-plus mr-2"></i>
              Nova Conta
              </router-link>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th>#</th>
                <th>Nome</th>
                <th>Agência</th>
                <th>Conta</th>
                <th>Tipo</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="bankAccount in bankAccounts.data" :key="bankAccount.id" class="c-black">
                <td class="align-middle">
                  <router-link :to="'./bank-accounts/' + bankAccount.id" class="btn btn-link c-black body-table">
                    {{ bankAccount.id }}
                  </router-link>
                </td>
                <td class="align-middle">
                  <router-link :to="'./bank-accounts/' + bankAccount.id" class="btn btn-link c-black body-table">
                    {{ bankAccount.bank.name }}
                  </router-link>
                </td>
                <td class="align-middle">
                  <router-link :to="'./bank-accounts/' + bankAccount.id" class="btn btn-link c-black body-table">
                    {{ bankAccount.agency_number }} {{ bankAccount.agency_digit_number }}
                  </router-link>
                </td>
                <td class="align-middle">
                  <router-link :to="'./bank-accounts/' + bankAccount.id" class="btn btn-link c-black body-table">
                    {{ bankAccount.account_number }} {{ bankAccount.account_digit_number }}
                  </router-link>
                </td>
                <td class="align-middle">
                  <router-link :to="'./bank-accounts/' + bankAccount.id" class="btn btn-link c-black body-table">
                    {{ bankAccount.type == 'checking' ? 'Corrente' : 'Poupança' }}
                  </router-link>
                </td>
                <td class="align-middle body-table px-0">
                  <button class="btn ml-4" @click="openDeleteModal(bankAccount.id)">
                    <i class="fas fa-times text-danger"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <PaginateComponent :source="pagination" @navigate="navigate"/>
      </div>
    </div>
    <LoadingComponent :loading="loading || !bankAccounts.data" />

    <!-- Modal excluir produto -->
    <div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="deleteModal" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row text-white">
              <div class="col-12 d-flex justify-content-end mb-3">
                <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="col-8 pb-2 pt-1 pl-3">
                <label class="form-control-label h4">Deseja excluir o produto?</label>
              </div>
              <div class="col-4 text-right">
                <button type="button" class="btn btn-outline-danger" @click="deletebankAccount(bankAccount_id)">Excluir</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex'
import LoadingComponent from '../../components/layout/LoadingComponent'
import PaginateComponent from '../../components/PaginateComponent'

export default {

  name: 'IndexBankAccountsPage',

  components: {
    LoadingComponent,
    PaginateComponent
  },

  data: function () {
    return {
      bankAccount_id: null
    }
  },

  computed: mapState({
    bankAccounts: state => state.bankAccounts.data,
    pagination: state => state.bankAccounts.pagination,
    loading: state => state.bankAccounts.loading
  }),

  methods: {

    ...mapActions('bankAccounts', [
      'index',
      'destroy'
    ]),

    openDeleteModal: function (id) {
      this.bankAccount_id = id
      $('#deleteModal').modal('show')
    },

    deletebankAccount: function (id) {
      this.destroy(id)
      $('#deleteModal').modal('hide')
    },

    searchWithPaginate (page) {
      this.index({ page: page, search: this.search, filter: this.filter })
      $('#searchModal').modal('hide')
    },

    navigate (page) {
      this.searchWithPaginate(page)
    }

  },

  mounted () {
    this.index({
      page: 1,
      name: null
    })
  }

}

</script>
